import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Chip } from './va-chip';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  template: `
    <mat-chip-listbox [selectable]="false">
      @if (config.text) {
        <mat-chip-option selected="true" color="{{ config.color }}">
          {{ config.text }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatChipsModule],
})
export class VaChipComponent {
  @Input() config: Chip;
}
